'use es6';

import styled from 'styled-components';
import UIDateRange from './UIDateRange';
import UIMicroDateInput from './UIMicroDateInput';
import { jsx as _jsx } from "react/jsx-runtime";
const DateRange = styled(UIDateRange).withConfig({
  displayName: "UIMicroDateRange__DateRange",
  componentId: "nwgxn9-0"
})(["display:inline-flex;"]);
const UIMicroDateRange = props => {
  return /*#__PURE__*/_jsx(DateRange, Object.assign({}, props));
};
UIMicroDateRange.propTypes = UIDateRange.propTypes;

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIMicroDateRange.defaultProps = Object.assign({}, UIDateRange.defaultProps, {
  DateInput: UIMicroDateInput
});
UIMicroDateRange.displayName = 'UIMicroDateRange';
export default UIMicroDateRange;